/*自定义绘制工具*/
class CustomerDraw {
  constructor(options) {
    this.map = options.map
    this.mapboxDraw = options.mapboxDraw
    this.curclickCallBackFunc = "";/*绘制完成回调*/
    this.curUpdateCallBackFunc = "";/*绘制更新回调*/
    this.curEditCallBackFunc = "";/*编辑更新回调*/

    this.auto_marker = true;/*是否自动添加测量结果的marker*/
    this.auto_clear_after_created = false
    this.handleCanvasClick_obj = "";/*点击函数，用于出合理bind不能移除事件的问题*/
    this.handleEsc_obj = "";/*esc函数，用于出合理bind不能移除事件的问题*/
  }


  /*
  * 绘制图形，完成后回调
  * @params type 绘制类型 三种("point","polygon","line" draw_point,draw_line_string,draw_polygon)(点线面)
  * @params createCallBack 创建新的图形回调
  * @params updateCallBack 更新图形回调
  * @params escCallBack esc回调
  * @params auto_clear_after_created 绘制完成后是否自动删除
  * @params auto_marker 是否自动添加测量结果
  */
  draw({type,auto_clear_after_created = false,createCallBack = "",updateCallBack = "",escCallBack = "",auto_marker = true}){
    this.auto_marker = auto_marker
    this.map.getCanvas().style.cursor='crosshair';/*修改鼠标指针样式*/
    this.auto_clear_after_created = auto_clear_after_created
    this.handleCallBack(createCallBack,updateCallBack,escCallBack);
    this.bindEvent();
    this.drawByType(type)
  }

  /*激活绘制类型*/
  drawByType(type){
    let realType = "";/*真实type*/
    /*传参type与真实type对照关系*/
    let typeRelation =  [{type:"point",realType:"draw_point"},{type:"line",realType:"draw_line_string"},{type:"polygon",realType:"draw_polygon"}]
    realType = typeRelation.find(item => {return item.type == type })
    if(realType){
      this.mapboxDraw.changeMode(realType.realType);
    }else{
      this.mapboxDraw.changeMode(type);
    }
  }

  /*处理回调*/
  handleCallBack(createCallBack,updateCallBack,escCallBack){
    this.curclickCallBackFunc = createCallBack;
    this.curUpdateCallBackFunc = updateCallBack;
    this.escCallBackFunc = escCallBack;
    this.map.on('draw.create',this.handleClickCallBack.bind(this));
    this.map.on('draw.update',this.handleUpdatekCallBack.bind(this));
    this.map.on('draw.update_polygon', this.update_polygon.bind(this))
    this.map.on('draw.update_line', this.update_line.bind(this))
    this.map.on('draw.esc', this.draw_esc.bind(this))

  }

  draw_esc(e){
    if(e.feature_id){
      this.del_marker(e.feature_id)
    }
  }

  /*实时更新多边形*/
  update_polygon(item){
    if(!this.auto_marker){return}
    let feature = item.feature
    let id = feature.properties.id
    let center = window.GLOBAL.calculate_tool.get_center_by_feature(feature)
    let lnglat = center.geometry.coordinates
    let area = window.GLOBAL.calculate_tool.get_area_by_feature(feature)
    let marker_id = id
    if(this.map["mearure_result"]){
      let exit_line_marker = this.map["mearure_result"].find(item =>{return item.deputy_marker_id == id})
      if(exit_line_marker){
        marker_id = exit_line_marker.marker_id
      }
    }
    window.GLOBAL.sys_marker_tool.add_marker(lnglat,{
      map:this.map,
      marker_type:'mearure_result',
      content:area + "平方米",
      marker_id:marker_id,
      deputy_marker_id:id
    })
  }

  /*实时更新线*/
  update_line(item){
    if(!this.auto_marker){return}
    let feature = item.feature
    let points = feature.geometry.coordinates

    let res = []
    for(let i = 1; i < points.length ; i++){
      if(points[i - 1][0] == points[i][0] && points[i - 1][1] == points[i][1]){
        return
      }
      let length = window.GLOBAL.calculate_tool.get_length_by_point(points[i - 1],points[i])

      res.push({
        point:points[i],
        content:length.toFixed(2) + "米",
        marker_id:feature.properties.id + "_" + i,
        deputy_marker_id:feature.properties.id
      })
    }
    res.forEach(item => {
      window.GLOBAL.sys_marker_tool.add_marker(item.point,{
        map:this.map,
        marker_type:'mearure_result',
        content:item.content,
        marker_id:item.marker_id,
        deputy_marker_id:item.deputy_marker_id
      })
    })
  }

  /*如果是点，给点添加测量结果*/
  add_point_marker(e){
    let lnglat = e.features[0].geometry.coordinates
    let id = e.features[0].id

    window.GLOBAL.sys_marker_tool.add_marker(lnglat,{
      map:this.map,
      marker_type:'mearure_result',
      content:{
        lnglat:lnglat
      },
      measure_point:true,
      marker_id:id,
      deputy_marker_id:id
    })
  }

  /*绘制完成回调*/
  handleClickCallBack(e){
    /*如果是点，给点添加测量结果*/
    if(e.features[0].geometry.type == "Point" && this.auto_marker){
      this.add_point_marker(e)
    }

    if(this.auto_clear_after_created){
      this.deleteGeo(e.features);
    }
    this.unbindEvent();
    if(this.curclickCallBackFunc){
      this.curclickCallBackFunc(e,this.map);
      this.curclickCallBackFunc = "";
    }
  }

  /*绘制更新回调*/
  handleUpdatekCallBack(e){
    this.unbindEvent();
    if(this.curUpdateCallBackFunc){
      this.curUpdateCallBackFunc(e);
      this.curUpdateCallBackFunc = "";
    }
  }

  /*处理事件*/
  bindEvent(){
    this.handleCanvasClick_obj = this.handleCanvasClick.bind(this);
    this.map.getCanvas().addEventListener('click', this.handleCanvasClick_obj);
    this.bindEsc();
  }

  /*绑定esc事件*/
  bindEsc(){
    this.handleEsc_obj = this.handleEsc.bind(this)
    document.addEventListener('keyup',this.handleEsc_obj);
  }

  /*解绑相关事件*/
  unbindEvent(){
    if(!this.map){return}
    try{
      if(this.map){this.map.getCanvas().style.cursor='';}
      document.removeEventListener('keyup',this.handleEsc_obj);
      this.map.getCanvas().removeEventListener('click',this.handleCanvasClick_obj);
    }catch (e) {
      console.log('测量工具解绑事件错误')
    }
  }

  /*事件独占*/
  handleCanvasClick(e){
    e.stopPropagation();/*阻止事件冒泡,保证重复检查的功能独占鼠标点击事件*/
    /*事件独占*/
    if(this.mapboxDraw){/*这里认为mode变为simple_select时说明draw已完成，不管是真的完成还是画多边
    形的时候重复点击导致的取消绘制（主要就是为了解决这个问题），都走这里一下*/
      let mode_type =  this.mapboxDraw.getMode()
      if(mode_type == "simple_select"){
        this.do_esc();
      }
    }
  }

  /*处理esc按钮*/
  handleEsc(e){
    if (e.keyCode == 27) {
      this.do_esc();
    }
  }

  /*按esc之后做的事*/
  do_esc(){
    this.del_editIng_polygon()
    this.unbindEvent();
    this.mapboxDraw.changeMode("simple_select");
    if(this.escCallBackFunc){
      this.escCallBackFunc()

    }
  }

  /*删除正在编辑的图形*/
  del_editIng_polygon(){
    /*如果有正在编辑的图形则删除*/
    if(this.edit_featureDrawIds){
      let final_del_marker_id = this.get_measure_id_by_feature(this.edit_featureDrawIds)
      this.mapboxDraw.delete(this.edit_featureDrawIds)
      this.del_marker(final_del_marker_id)
    }
  }

  //编辑节点
  edit(features, escCallback) {
    // this.map.getCanvas().style.cursor='crosshair';/*修改鼠标指针样式*/
    this.bindEsc();
    this.handleCallBack("","",escCallback);
    let featureIds = this.mapboxDraw.add(features);
    this.edit_featureDrawIds = featureIds;
    // this.map.on('draw.update', this.handleEditCallBack);
  }

  /*获取编辑的数据*/
  getEditedPolygon(){
    this.unbindEvent();
    if(this.edit_featureDrawIds){
      let edit_feature =  this.mapboxDraw.get(this.edit_featureDrawIds)
      this.del_editIng_polygon();
      this.edit_featureDrawIds = ""
      return edit_feature
    }
    return ""
  }

  /*编辑节点的回调函数*/
  handleEditCallBack(e){
    this.unbindEvent();
    if(this.curEditCallBackFunc){
      this.curEditCallBackFunc(e);
      this.curEditCallBackFunc = "";
    }
  }

  /*清除全部绘制的图形*/
  clear() {
    let final_del_marker_id = []
    let cur_features = this.mapboxDraw.getAll().features
    if(cur_features){
      final_del_marker_id = this.get_measure_id_by_feature(cur_features)
    }

    this.mapboxDraw.deleteAll()
    this.del_marker(final_del_marker_id)
  }

  /*删除第三方插件绘制的图形*/
  deleteGeo(features){
    if(!(features instanceof Array)){
      features = [features]
    }

    let final_del_marker_id = this.get_measure_id_by_feature(features)
    features.forEach(item =>{
      if(item.id){this.mapboxDraw.delete(item.id)}
    })
    this.del_marker(final_del_marker_id)
  }

  /*通过绘制的feautres获取其id*/
  get_measure_id_by_feature(features){
    let final_del_marker_id = []
    if(features instanceof Array){
      features.forEach(item => {
        final_del_marker_id.push(item.id)
      })
    }else{
      final_del_marker_id = [features.id]
    }
    return final_del_marker_id
  }

  /*删除测量结果对应的marker*/
  del_marker(del_marker_id){
    if(!del_marker_id || del_marker_id.length == 0){return }
    window.GLOBAL.sys_marker_tool.del_measure_marker(del_marker_id,{
      map:this.map
    })
  }

  /*返回所有feature*/
  get_all_feature(){
    return  this.mapboxDraw.getAll().features
  }

}

export default CustomerDraw



// WEBPACK FOOTER //
// ./src/components/2DMap/draw_tool/customerDraw.js